// React & Libraries
import React, { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

// Ant Design Components
import {
  Popconfirm,
  notification,
  Popover,
  Button,
} from 'antd';
import {
  EditOutlined,
  LoadingOutlined,
} from '@ant-design/icons';

// Assets & Constants
import Crown from '@Images/crown2.png';
import Constants from '@Apis/constants';

// Helpers & Utilities
import Helpers from '@Apis/helpers';
import { addAlpha } from '../helper';

// UI Components
import H3Text from '../../../../../uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import SelectCustomStatus from '@Components/Common/SelectCustomStatus';

function ViewPackingSlipHeader({
  selectedSO,
  user,
  isQuickView,
  updateSOStatus,
  deleteSO,
  getSOById,
  updateSOStatusLoading,
  deleteSOLoading,
  history,
  downloadDocument,
  cancellationReason,
  currentUpdate,
  dispatch,
  currentTenantId,
  currentOrderId,
  salesOrderType,
  cancelShopifyOrderLoading
}) {
  return (
    <Fragment>
      <div className="view-document__title">
        <div className="view-document__title-number-wrapper">
          <H3Text
            text={selectedSO?.sales_order_number}
            className="view-document__title-number"
          />
        </div>

        {!isQuickView && (
          <div className="view-document__title-actions">
            <div className="action-buttons">
              {Helpers.getPermission(
                Helpers.permissionEntities.SALES_ORDER,
                Helpers.permissionTypes.UPDATE,
                user,
              ) && (
                <H3Text
                  text={(
                    <div
                      onClick={() => {
                        if (
                          selectedSO?.invoices?.length > 0
                            || selectedSO?.sales_orders?.length > 0
                        ) {
                          notification.error({
                            message: 'Sorry, you are not allowed to edit a packing slip for which Invoice has been created.',
                            placement: 'top',
                            duration: 4,
                          });
                        } else {
                          history.push(
                              `/sales/packing-slip/update/${selectedSO?.order_id}`,
                          );
                        }
                      }}
                    >
                      <EditOutlined />
                    </div>
                  )}
                  className="action-button"
                />
              )}
              <H3Text
                text={(
                  <FontAwesomeIcon
                    icon={faPrint}
                    style={{
                      fontSize: '16px',
                      width: '35px',
                      textAlign: 'center',
                    }}
                  />
                )}
                onClick={() => downloadDocument({
                  url: `${Constants.SO}/download?order_id=${selectedSO?.order_id}`,
                  document_type: 'PACKING_SLIP',
                  document_number: selectedSO?.sales_order_number,
                  key: uuidv4(),
                })}
                className="action-button"
              />
            </div>
            <div className="action-buttons">
              {selectedSO?.custom_status_info?.type !== 'VOID'
                && Helpers.getPermission(
                  Helpers.permissionEntities.SALES_ORDER,
                  Helpers.permissionTypes.UPDATE,
                  user,
                ) && (
                <Popover
                  placement="topRight"
                  title="Are you sure you want to cancel this packing slip ?"
                  content={(
                    <React.Fragment>
                      {' '}
                      <H3FormInput
                        name="cancellation reason"
                        type="text"
                        containerClassName="orgInputContainer create__right-input"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput"
                        placeholder=""
                        onChange={(event) => dispatch({
                          type: 'SET_CANCELLATION_REASON',
                          payload: event.target.value,
                        })}
                        value={cancellationReason}
                        label="Cancellation reason"
                        maxlength="100"
                        required
                        showError={
                          currentUpdate === 'VOID'
                            && !cancellationReason
                        }
                      />
                      <div className="view-document__cancellation-buttons">
                        <Button
                          onClick={() => {
                            if (selectedSO?.shopify_order_id) {
                              if (cancellationReason) {
                                dispatch({
                                  type: 'SET_CANCELLATION_REASON',
                                  payload: '',
                                });
                                dispatch({
                                  type: 'SET_CURRENT_UPDATE',
                                  payload: '',
                                });
                                dispatch({
                                  type: 'SET_CANCELLATION_POP',
                                  payload: false,
                                });
                              }
                            } else {
                              dispatch({
                                type: 'SET_CURRENT_UPDATE',
                                payload: 'VOID',
                              });
                              if (cancellationReason) {
                                updateSOStatus(
                                  {
                                    status: 'VOID',
                                    order_id: selectedSO?.order_id,
                                    cancellation_reason:
                                        cancellationReason,
                                  },
                                  () => {
                                    const payload = {
                                      orgId:
                                          user?.tenant_info?.org_id,
                                      tenantId: currentTenantId,
                                      soId: currentOrderId,
                                      orderType: salesOrderType,
                                    };
                                    getSOById(payload);
                                    dispatch({
                                      type: 'SET_CANCELLATION_REASON',
                                      payload: '',
                                    });
                                    dispatch({
                                      type: 'SET_CURRENT_UPDATE',
                                      payload: '',
                                    });
                                  },
                                );
                                dispatch({
                                  type: 'SET_CANCELLATION_POP',
                                  payload: false,
                                });
                              }
                            }
                          }}
                          type="primary"
                          size="small"
                        >
                          Submit
                        </Button>
                      </div>
                    </React.Fragment>
                  )}
                  trigger="click"
                >
                  <H3Text
                    text={(
                      <div
                        style={{
                          width: '50px',
                          textAlign: 'center',
                        }}
                      >
                        {(updateSOStatusLoading
                          && currentUpdate === 'VOID')
                          || cancelShopifyOrderLoading ? (
                            <LoadingOutlined />
                          ) : (
                            <span>Cancel</span>
                          )}
                      </div>
                    )}
                    onClick={() => {
                      if (selectedSO?.invoices?.length > 0) {
                        notification.error({
                          message:
                            `Sorry, you are not allowed to cancel a packing slip for which Invoice has been created.`,
                          placement: 'top',
                          duration: 4,
                        });
                        dispatch({
                          type: 'SET_CANCELLATION_POP',
                          payload: false,
                        });
                      } else {
                        dispatch({
                          type: 'SET_CANCELLATION_POP',
                          payload: true,
                        });
                      }
                    }}
                    className="action-button action-button-big"
                  />
                </Popover>
              )}
              {Helpers.getPermission(
                Helpers.permissionEntities.SALES_ORDER,
                Helpers.permissionTypes.DELETE,
                user,
              ) && (
                <Popconfirm
                  placement="topRight"
                  title="Are you sure you want to packing slip ?"
                  onConfirm={() => {
                    if (
                      selectedSO?.invoices?.length > 0
                        || selectedSO?.sales_orders?.length > 0
                    ) {
                      notification.error({
                        message: 'Sorry, you are not allowed to delete a packing slip for which Invoice has been created.',
                        placement: 'top',
                        duration: 4,
                      });
                    } else {
                      deleteSO(
                        {
                          tenant_id: selectedSO?.tenant_id,
                          order_id: currentOrderId,
                        },
                        () => {
                          history.push('/sales/packing-slips');
                        },
                      );
                    }
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <H3Text
                    text={(
                      <div>
                        {deleteSOLoading ? (
                          <LoadingOutlined />
                        ) : (
                          <span>Delete</span>
                        )}
                      </div>
                    )}
                    className="action-button action-button-big"
                  />
                </Popconfirm>
              )}
              {!['VOID'].includes(
                selectedSO?.custom_status_info?.type,
              )
                && ['CONFIRMED'].includes(
                  selectedSO?.custom_status_info?.type,
                )
                && Helpers.getPermission(
                  Helpers.permissionEntities.INVOICE,
                  Helpers.permissionTypes.CREATE,
                  user,
                )
                && !selectedSO?.invoices?.length && (
                <H3Text
                  style={{
                    width: '110px',
                    borderRight: 'none',
                    whiteSpace: 'nowrap',
                  }}
                  className="action-button action-button-big"
                  text={(
                    <div>
                      <span>+ Invoice</span>
                      {!user?.tenant_info?.sales_config?.sub_modules
                        ?.invoice?.is_active && (
                        <Popconfirm
                          placement="topRight"
                          title="This feature is not accessible within your current plan to use this feature contact us."
                          // eslint-disable-next-line unicorn/prefer-global-this
                          onConfirm={() => window.Intercom('showNewMessage')}
                          okText="Contact Us"
                          cancelText="Cancel"
                        >
                          <img
                            className="barcode-restrict"
                            style={{ marginLeft: '4px' }}
                            src={Crown}
                            alt="premium"
                          />
                        </Popconfirm>
                      )}
                    </div>
                  )}
                  onClick={() => dispatch({ type: 'SET_SHOW_NEW_INVOICE_FORM', payload: true })}
                />
              )}
              {Helpers.getPermission(
                Helpers.permissionEntities.PACKING_SLIP,
                Helpers.permissionTypes.UPDATE,
                user,
              )
                && selectedSO?.custom_status_info?.type !== 'VOID' && (
                <SelectCustomStatus
                  selectedCustomStatus={
                    selectedSO?.custom_status_id
                  }
                  hideTitle
                  tenantId={selectedSO?.tenant_id}
                  posibleStatuses={[
                    selectedSO?.custom_status_info,
                    ...(selectedSO?.possible_status ?? []),
                  ]}
                  onChange={(value) => {
                    updateSOStatus(
                      {
                        status: value?.type,
                        secondary_status: value?.status_name,
                        order_id: selectedSO?.order_id,
                        custom_status_id: value?.custom_status_id,
                      },
                      () => {
                        const payload = {
                          orgId: user?.tenant_info?.org_id,
                          tenantId: currentTenantId,
                          soId: currentOrderId,
                          orderType: salesOrderType,
                        };
                        getSOById(payload);
                      },
                    );
                  }}
                  disabled={['VOID', 'SENT_FOR_APPROVAL'].includes(
                    selectedSO?.custom_status_info?.type,
                  )}
                  customStyle={{
                    color:
                        selectedSO?.custom_status_info?.color_code,
                    backgroundColor: addAlpha(
                      selectedSO?.custom_status_info?.color_code,
                      1,
                    ),
                    height: '35px',
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </Fragment>
  )
}

export default ViewPackingSlipHeader;
